import { useContext, useEffect } from 'react';

import { EuiBreadcrumb } from '@elastic/eui';

import { TopMenuContext } from './Context';

export const useSetBreadcrumbs = (items: EuiBreadcrumb[]) => {
  const context = useContext(TopMenuContext);

  useEffect(() => {
    context?.setBreadcrumbs(items);
    return () => context?.setBreadcrumbs([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(items)]);
};
